import Users from './actions/users';
import Participants from './actions/participants';
import Roles from './actions/roles';
import EventRoles from './actions/event_roles';

const actions = {
  ...Users,
  ...Participants,
  ...Roles,
  ...EventRoles,
};

export default actions;
